import OpenWineCardSaveRemainVolumeField from './OpenWineCardSaveRemainVolumeField'

// 开瓶存酒计量单位
const UNIT_CM = 'cm' // 厘米

const map = new Map([
  [
    UNIT_CM,
    {
      mean: 'cm',
      field: OpenWineCardSaveRemainVolumeField.FIELD_CM,
      placeholder: '非整瓶酒水厘米数'
    }
  ]
])

export default {
  map,
  UNIT_CM
}
